import Fernet from 'fernet';
import axios from 'axios';

const FERNET_KEY = '8y4Ia5t_jQpDr_PNlpSvye8Dmeft1HwnsC1OadsDRaI=';
const AUTO_LOGIN_URL = 'https://console.ffeleven.com/administration/num_reporting/auto_login';

const createLoginToken = (username, password) => {
  const secret = new Fernet.Secret(FERNET_KEY);
  const token = new Fernet.Token({
    secret: secret,
    time: Date.now(),
  });
  return token.encode([username, password].join(':'));
};

const autoLogin = async (username, password) => {
  const encryptedMessage = createLoginToken(username, password);
  const response = await axios.get(`${AUTO_LOGIN_URL}?token=${encryptedMessage}`, {
    withCredentials: true,
  });
  return response.data && response.data.status === 'SUCCESS';
};

export const refreshConsoleSession = async () => {
  const username = localStorage.getItem('username');
  const password = localStorage.getItem('console_password');
  if (!username || !password) {
    return false;
  }
  try {
    return await autoLogin(username, password);
  } catch (error) {
    console.error('Failed to refresh console session:', error);
    return false;
  }
};

export const openConsoleAdmin = async (url) => {
  const popup = window.open('about:blank', '_blank');
  await refreshConsoleSession();
  if (popup && !popup.closed) {
    popup.opener = null;
    popup.location.href = url;
    return;
  }
  window.location.href = url;
};

export const authProvider = {
    login: async ({ username, password }) => {
      
      const handlelogin = async()=>{
        try {
          const status = await autoLogin(username, password);
          return status;
        } catch (error) {
          console.error('Network or fetch error:', error);
          return false; 
        }
      }

      const status = await handlelogin();

      if (status) {
        localStorage.setItem('auth', 'true');
        localStorage.setItem('username',username);
        localStorage.setItem('console_password', password);
        return Promise.resolve();
      }else{
        return Promise.reject('Invalid credentials');
      }      
    },
    logout: () => {
      if(localStorage.getItem('auth') && localStorage.getItem("username")){
        localStorage.clear();
        return Promise.resolve();
      }
      return Promise.reject('Error in logging out !');
    },
    checkAuth: () => {
      return localStorage.getItem('auth') ? Promise.resolve() : Promise.reject();
    },
    checkError: (error) => Promise.reject(error),
    getPermissions: () => Promise.resolve(),
  };
